<template>
  <div class="popup-full">
    <div class="popup-full__wrap">
      <BasePreloader v-if="pending"/>
      <button type="button"
              @click.prevent="close"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <div v-if="!pending" class="popup-full__content">
          <div class="popup-full__media">
            <picture class="popup-full__img">
              <img src="../../assets/img/resume-popups/response.svg" :alt="$tVacancy('Apply for job')">
            </picture>
          </div>

          <RespondOnVacancyStatuses v-if="status || sentMessage"
                                    :status="status"
                                    :message="sentMessage"
                                    @close="close"/>

          <template v-else>
            <h3 class="popup-full__title">{{ $tVacancy('Respond to the vacancy') }}</h3>
            <div class="popup-full__text text">
              <p>{{ $tVacancy('Respond to the vacancy description') }}</p>
            </div>
            <div class="popup-full__checkbox-row">
              <BaseCheckbox v-model="checked"
                            :label="$tVacancy('I have read the vacancy and its requirements')"/>
            </div>
            <div class="popup-full__buttons">
              <button v-if="checked"
                      type="button"
                      @click="onResumeClick"
                      class="popup-full__btn  base-btn base-btn--green">
                <span>{{ $tVacancy('Respond') }}</span>
                <BasePreloader v-if="pendingButton"/>
              </button>
              <button v-else
                      type="button"
                      disabled
                      class="popup-full__btn  base-btn base-btn--green">
                <span>{{ $tVacancy('Respond') }}</span>
              </button>
            </div>
          </template>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from "@/axios"
  import formMixins from "@/mixins/formMixins"
  import RespondOnVacancyStatuses from "@/components/RespondOnVacancyStatuses"

  const STATUS_SUCCESS = 'STATUS_SUCCESS'
  const STATUS_NO_PASSPORTS = 'STATUS_NO_PASSPORTS'
  const STATUS_NO_RESUME = 'RESUME_NOT_FOUND'
  const STATUS_PASSPORTS_NO_MODERATE = 'STATUS_PASSPORTS_NO_MODERATE'
  const STATUS_RESUME_FOUNT_ON_THIS_VACANCY = 'STATUS_RESUME_FOUNT_ON_THIS_VACANCY'

  export default {
    mixins: [formMixins],
    components: {
      RespondOnVacancyStatuses
    },
    props: {
      vacancyId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        checked: false,
        items: {},
        pending: false,
        pendingButton: false,
        sentMessage: null,
        showSendMessage: false,
        status: null,
        STATUS_SUCCESS,
        STATUS_NO_RESUME,
        STATUS_NO_PASSPORTS,
        STATUS_PASSPORTS_NO_MODERATE,
        STATUS_RESUME_FOUNT_ON_THIS_VACANCY,
      }
    },
    computed: {
      hasResume() {
        return !!Object.keys(this.items).length
      }
    },
    methods: {
      close() {
        this.$vModal.close('respond-on-vacancy')
      },
      onResumeClick() {
        if (!this.vacancyId) return
        this.pendingButton = true
        this.pending = true
        this.sentMessage = null
        this.resetErrorsMix()

        // let resumeObject = {}
        // Object.keys(this.items).forEach(key => {
        //   resumeObject = this.items[key]
        // })
        // const id = resumeObject[0].resume_id

        http.post(`/api/vacancy/${this.vacancyId}/send-resume`, {
        }).then(({data}) => {
          if (data.status === STATUS_SUCCESS) {
            return this.goToMyVacancies()
          } else {
            this.close()
            this.$vModal.open('after-respond-without-resume')
          }

          // this.status = data.status
          // this.sentMessage = data.message
        }).catch(error => {
          if (!error.response) {
            return this.sentMessage = error.message
          }

          this.sentMessage = error.response.data && error.response.data.message || error.response.message
        }).finally(() => {
          this.pendingButton = false
          this.pending = false
          this.showSendMessage = true
        })
      },
      async load() {
        this.pending = true
        await this.$store.dispatch('user/loadUser')

        http.get('/api/vacancy/get-resumes-for-send').then(({data}) => {
          if (data.data.status) {
            this.status = data.data.status
          } else if (data.data.code === 0) {
            this.sentMessage = data.data.msg
          } else {
            this.items = data.data
          }
        }).finally(() => {
          this.pending = false
        })
      },
      goToMyVacancies() {
        this.$router.push({
          name: 'account-my-vacancies',
          query: {
            showModalInfo: false // !isShownModalInfoResult ? 'true' : null
          }
        })

        this.close()
      },
    },
    created() {
      // this.load()
      this.onResumeClick()
    }
  }

  // function isShownModalInfo() {
  //   return localStorage.getItem('shownModalInfo') === 'true'
  // }
  //
  // function setShownModalInfo() {
  //   localStorage.setItem('shownModalInfo', 'true')
  // }
</script>

<style lang="less">

</style>
